var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('MainSelect'),_vm._v(" "),_vm._l((_vm.locationsConnections),function(connection){return _c('Connection',{key:connection.remoteId,attrs:{"connection":connection}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }